export default {
  cambioItens: [],
  selectedCambio: {},
  colunasDisponiveis: [
    {
      label: 'referenciaCliente',
      field: 'referenciaCliente',
      width: '176px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'referenciaTrust',
      field: 'codigoProcesso',
      hidden: false,
      type: 'text',
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'cambio',
        fetch: 'fetchInformacoesCambio',
      },
      flex: 1,
    },
    {
      label: 'invoice',
      field: 'codigoInvoice',
      width: '107px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'Exportador',
      field: 'nomeExportador',
      width: '190px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'modalidade',
      field: 'modalidade',
      width: '263px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'porcentagem',
      field: 'pctValor',
      width: '175px',
      hidden: false,
      type: 'text',
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'cambio',
        fetch: 'fetchInformacoesCambio',
      },
      maxWidth: 108,
    },
    {
      label: 'tipoVencimento',
      field: 'tipoVencimento',
      width: '170px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'vencimento',
      field: 'dataVencimento',
      width: '140px',
      hidden: false,
      comparator: () => false,
      filter: 'DateFilter',
      filterParams: {
        module: 'cambio',
        fetch: 'fetchInformacoesCambio',
        colDef: {
          field: 'dataVencimento',
        },
      },
      flex: 1,
    },
    {
      label: 'dias',
      field: 'diasVencimento',
      hidden: false,
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'cambio',
        fetch: 'fetchInformacoesCambio',
      },
      flex: 1,
    },
    {
      label: 'dataPagamento',
      field: 'dataPagamento',
      hidden: false,
      comparator: () => false,
      filter: 'DateFilter',
      filterParams: {
        module: 'cambio',
        fetch: 'fetchInformacoesCambio',
      },
      flex: 1,
    },
    {
      label: 'moeda',
      field: 'moeda',
      width: '117px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'valor',
      field: 'valor',
      width: '100px',
      hidden: false,
      type: 'text',
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'cambio',
        fetch: 'fetchInformacoesCambio',
      },
      flex: 1,
    },
  ],
  colunasDinamicasCambio: [],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    periodo: [],
    campoData: [],
    codigoProcesso: '',
    referenciaCliente: '',
    codigoInvoice: '',
    nomeExportador: '',
    modalidade: '',
    pctValor: '',
    tipoVencimento: '',
    dataVencimento: '',
    dataVencimentoCondicao: '',
    diasVencimento: '',
    dataPagamento: '',
    dataPagamentoCondicao: '',
    moeda: '',
    valor: '',
    order: '"dataVencimento"',
    direcao: '',
  },
  campos: {
    id: 'ID',
    codigoProcesso: '"codigoProcesso"',
    referenciaCliente: '"referenciaCliente"',
    codigoInvoice: '"codigoInvoice"',
    nomeExportador: '"nomeExportador"',
    modalidade: '"modalidade"',
    pctValor: '"pctValor"',
    tipoVencimento: '"tipoVencimento"',
    dataVencimento: '"dataVencimento"',
    diasVencimento: '"diasVencimento',
    dataPagamento: '"dataPagamento"',
    moeda: '"moeda"',
    valor: '"valor"',
  },
  colDefault: '"dataVencimento"',
  directionDefault: '',
};
